/* DateFieldFr — champ date localisé JJ/MM/AAAA (présentation uniquement).
 * La valeur émise reste au format canonique ISO yyyy-MM-dd pour le serveur. */
import { useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { fr } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function DateFieldFr({ value, onChange, className = "", testid = "date-field-fr", placeholder = "JJ/MM/AAAA" }) {
  const [open, setOpen] = useState(false);
  const parsed = value ? parseISO(value) : undefined;
  const date = parsed && isValid(parsed) ? parsed : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={`noam-input flex items-center gap-1.5 text-left ${!value ? "text-zinc-500" : ""} ${className}`}>
          <CalendarIcon className="w-3 h-3 shrink-0 opacity-60" />
          {date ? format(date, "dd/MM/yyyy") : placeholder}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[70] bg-[#0F1114] border-white/10 text-white shadow-2xl" align="start">
        <Calendar
          mode="single"
          locale={fr}
          selected={date}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
